import { NavLink } from "react-router-dom";
import { X } from "lucide-react";
import { NAV_ITEMS } from "./nav-items";

type SidebarProps = { open?: boolean; onClose?: () => void };

function SidebarContent({ onClose }: { onClose?: () => void }) {
  const mainItems = NAV_ITEMS.filter((item) => item.section === "main");
  const managementItems = NAV_ITEMS.filter((item) => item.section === "management");

  return (
    <div className="flex h-full flex-col">
      <div className={`flex items-center px-4 py-4 ${onClose ? "justify-between" : "justify-center"}`}>
        <img src="/logo.jpeg" alt="Lakshya Sports Academy" className="w-40 object-contain" />
        {onClose && (
          <button type="button" onClick={onClose} className="rounded-lg p-1.5 text-[#8ca0bf] hover:bg-[#edf2fb] lg:hidden">
            <X className="h-5 w-5" />
          </button>
        )}
      </div>

      <nav className="space-y-1 px-4">
        {mainItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onClose}
              className={({ isActive }) =>
                [
                  "flex items-center gap-3 rounded-xl px-4 py-3 text-xl font-medium transition-colors",
                  isActive
                    ? "bg-primary text-white shadow-[0_10px_20px_-14px_rgba(37,84,205,0.8)]"
                    : "text-[#31486b] hover:bg-[#edf2fb]",
                ].join(" ")
              }
            >
              <Icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      <div className="mt-8 px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#8ca0bf]">Management</p>
      </div>
      <nav className="mt-3 space-y-1 px-4">
        {managementItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={onClose}
              className={({ isActive }) =>
                [
                  "flex items-center gap-3 rounded-xl px-4 py-3 text-lg font-medium transition-colors",
                  isActive ? "bg-[#eaf0ff] text-primary" : "text-[#4b6286] hover:bg-[#edf2fb]",
                ].join(" ")
              }
            >
              <Icon className="h-5 w-5" />
              {item.label}
            </NavLink>
          );
        })}
      </nav>

    </div>
  );
}

export function Sidebar({ open, onClose }: SidebarProps) {
  return (
    <>
      {/* Desktop — always visible */}
      <aside className="hidden min-h-screen w-[280px] shrink-0 flex-col border-r border-border/70 bg-white lg:flex">
        <SidebarContent />
      </aside>

      {/* Mobile — backdrop + slide-in drawer */}
      {open && (
        <div className="fixed inset-0 z-40 lg:hidden" aria-modal="true">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
            onClick={onClose}
          />
          {/* Drawer */}
          <aside className="absolute inset-y-0 left-0 flex w-[280px] flex-col border-r border-border/70 bg-white shadow-2xl">
            <SidebarContent onClose={onClose} />
          </aside>
        </div>
      )}
    </>
  );
}
